<template>
  <div>
    <div class="max-w-screen-sm mx-auto space-y-6">
      <div>
        <button
          type="button"
          class="font-bold inline-flex items-center text-xl"
          @click="$emit('on:back')"
          aria-label="Back to Appointment Schedule"
        >
          <svg-chevron-left class="mr-4" aria-hidden="true" role="img"></svg-chevron-left>
          Back to Appointment Schedule
        </button>
      </div>
      <div
        class="grid grid-cols-1 divide-y md:divide-y-0 md:grid-cols-3 md:gap-6 border-b md:pb-6"
        role="region"
        aria-label="Appointment Details"
      >
        <div class="flex flex-col space-y-2 py-3 md:py-0">
          <span class="text-sm font-semibold" id="location-label">Location</span>
          <span class="leading-tight text-lg font-bold" aria-labelledby="location-label">{{
            form.location.name
          }}</span>
        </div>
        <div class="flex flex-col space-y-2 py-3 md:py-0">
          <span class="text-sm font-semibold" id="service-label">Service</span>
          <span class="leading-tight text-lg font-bold" aria-labelledby="service-label">
            {{ form.service.name }}
          </span>
        </div>
        <div class="flex flex-col space-y-2 py-3 md:py-0">
          <span class="text-sm font-semibold" id="datetime-label">Date & Time</span>
          <span class="leading-tight text-lg font-bold" aria-labelledby="datetime-label">
            <formatter :value="time" v-slot="{ formats }">
              {{ formats[2] }} {{ formats[0] }}
            </formatter>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgChevronLeft from "@/components/Svg/SvgChevronLeft.vue";
import Formatter from "@/components/Sameday/SamedayTimeFormatter.vue";

export default {
  components: {
    SvgChevronLeft,
    Formatter,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    control: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    time() {
      return {
        date: this.control?.availability?.date,
        start: this.control?.availability?.time?.start,
      };
    },
  },
};
</script>
